const RANKS = [
  {
    name: "逆风者",
    idx: "01",
    score: 96,
    delta: "↑ 2",
    desc: "越被唱衰越受关注，翻盘叙事完整",
    tag: "领跑候选",
  },
  {
    name: "深水区",
    idx: "02",
    score: 89,
    delta: "↑ 1",
    desc: "多份旧账底稿被重新翻译，变量最足",
    tag: "黑马",
  },
  {
    name: "临界点",
    idx: "03",
    score: 81,
    delta: "——",
    desc: "结束三个月隐身，公开动态连发",
    tag: "回归",
  },
  {
    name: "回声室",
    idx: "04",
    score: 74,
    delta: "↑ 9",
    desc: "单周上升九位，一条旧录音带动热度",
    tag: "本周跳升",
  },
  {
    name: "风向标",
    idx: "05",
    score: 68,
    delta: "↓ 1",
    desc: "热评三连后被质疑「自我造浪」",
    tag: "存疑",
  },
  {
    name: "万花筒",
    idx: "06",
    score: 60,
    delta: "——",
    desc: "多次被提名人选，但争议素材显单一",
    tag: "常驻",
  },
];

export default function HeatRank() {
  return (
    <section id="rank" className="border-t border-[#e4d9c6] bg-[#f1e9da]">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="text-xs font-semibold tracking-[0.25em] text-[#b03a2e] uppercase">
              Heat Ranking
            </p>
            <h2 className="font-display mt-2 text-2xl font-black text-[#18130e] md:text-4xl">
              本周候选人热度榜
            </h2>
          </div>
          <div className="flex items-center gap-2 text-xs text-[#4a4036]">
            <span className="inline-flex h-2 w-2 rounded-full bg-[#b03a2e]"></span>
            综合提及量 · 转发扩散 · 评论情绪加权
            <span className="text-[#8a6b4f]">统计至今日 09:00</span>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-3">
          {/* ranking list */}
          <div className="rounded-xl border border-[#e4d9c6] bg-[#fbf7ef] p-2 lg:col-span-2 md:p-3">
            {RANKS.map((r, i) => (
              <div
                key={r.name}
                className={`group flex flex-col gap-3 rounded-lg px-4 py-4 transition-colors hover:bg-[#f1e7d2] sm:flex-row sm:items-center ${
                  i === 0 ? "bg-[#f6ecdc]" : ""
                }`}
              >
                <div className="flex items-center gap-4 sm:w-[240px]">
                  <span
                    className={`font-display w-9 text-3xl font-black ${
                      i === 0 ? "text-[#b03a2e]" : "text-[#c9b795]"
                    }`}
                  >
                    {r.idx}
                  </span>
                  <div>
                    <div className="flex items-center gap-2">
                      <span className="font-display text-lg font-bold text-[#18130e] group-hover:text-[#8f2a20]">
                        {r.name}
                      </span>
                      <span className="rounded bg-[#e9dcc6] px-2 py-0.5 text-[11px] font-semibold text-[#6b4a2c]">
                        {r.tag}
                      </span>
                    </div>
                    <p className="mt-1 text-xs text-[#6b5a48]">{r.desc}</p>
                  </div>
                </div>

                <div className="flex flex-1 items-center gap-3">
                  <div className="hidden h-1.5 w-full overflow-hidden rounded-full bg-[#e6d9c0] md:block">
                    <div
                      className="h-full rounded-full bg-gradient-to-r from-[#b03a2e] to-[#d98a6a]"
                      style={{ width: `${r.score}%` }}
                    ></div>
                  </div>
                  <span className="w-8 text-right text-[#b03a2e]">
                    <b className="font-display text-xl">{r.score}</b>
                  </span>
                </div>
                <span
                  className={`w-12 text-xs font-bold ${
                    r.delta.startsWith("↑")
                      ? "text-[#b03a2e]"
                      : r.delta.startsWith("↓")
                        ? "text-[#7a6b52]"
                        : "text-[#c9b795]"
                  }`}
                >
                  {r.delta}
                </span>
              </div>
            ))}
          </div>

          {/* side: lead nominee dossier */}
          <div className="flex flex-col gap-5">
            <div className="overflow-hidden rounded-xl border border-[#e4d9c6] bg-[#fbf7ef]">
              <img
                src="https://readdy.ai/api/search-image?query=abstract%20portrait%20silhouette%20in%20shadow%20with%20single%20red%20light%20beam%2C%20dark%20editorial%20magazine%20photo%2C%20film%20noir%20atmosphere%2C%20cream%20background%20with%20ink%20texture%2C%20minimal%20dramatic%20lighting%2C%20high%20contrast%20news%20magazine%20art&width=760&height=560&seq=rank-leader-02&orientation=portrait"
                alt="领跑候选人档案 逆风者"
                title="逆风者领跑黑料王候选人热度"
                className="h-44 w-full object-cover object-top md:h-52"
              />
              <div className="p-5">
                <p className="text-xs font-semibold tracking-wide text-[#b03a2e]">
                  本期领跑 · 候选人档案
                </p>
                <h3 className="font-display mt-2 text-xl font-bold text-[#18130e]">
                  逆风者
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-[#4a4036]">
                  热度 96，综合榜单连续四周第一。争议素材厚度与围观情绪同步见顶，是当前最接近"黑料王下一位人选"的候补。
                </p>
              </div>
            </div>

            <div className="rounded-xl border border-[#b03a2e]/25 bg-[#b03a2e]/5 p-5">
              <p className="text-xs font-semibold tracking-wide text-[#b03a2e]">
                本刊判定
              </p>
              <p className="mt-2 text-sm leading-relaxed text-[#18130e]">
                热榜前三的争夺已进入「素材存量」对「发酵节奏」的消耗战。悬念不在会不会易主，而在何时易主。
              </p>
              <a href="#feed" className="mt-3 inline-block text-sm font-semibold text-[#8f2a20]">
                看争夺时间线 →
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}